import { Card } from "@cmsgov/ds-medicare-gov";
import React, { FunctionComponent } from "react";
import { InNetworkLabel, OutOfNetworkLabel } from "../../../components";

interface PharmacyCardProps {
  name: string;
  address?: string;
  isPreferred?: boolean;
  isInNetwork?: boolean;
  shouldShowPharmacyLabels?: boolean;
}

const PharmacyCard: FunctionComponent<PharmacyCardProps> = ({
  name,
  address,
  isPreferred = false,
  isInNetwork = false,
  shouldShowPharmacyLabels = false,
}) => {
  return (
    <Card className="mct-c-summary-page-pharmacy-card">
      {shouldShowPharmacyLabels && (
        <span className="mct-c-summary-page-pharmacy-card__label">
          {isInNetwork ? (
            <InNetworkLabel preferred={isPreferred} wide={true} />
          ) : (
            <OutOfNetworkLabel wide={true} />
          )}
        </span>
      )}
      <h3 className="ds-text-heading--lg mct-c-summary-page-pharmacy-card__name ds-u-margin-bottom--1">
        {name}
      </h3>
      {address && (
        <p className="ds-u-measure--base ds-u-font-size--md ds-u-margin-y--0">
          {address}
        </p>
      )}
    </Card>
  );
};

export default PharmacyCard;
